import Cookies from 'js-cookie';

import type { Property } from '@ts-types/property';

import type { PropertyRowStatus } from './components/PropertyRow/PropertyRow.types';

export const canInteract = (p: Property): boolean => {
  const isBroken = p.status === 'broken' || p.status === 'warning';
  const isLocked = p.status === 'data' && p.data && p.locked;
  const needsDownload = p.status === 'data' && !p.data && !p.fetch;
  const isLoading =
    p.status === 'running' ||
    p.status === 'set_visible' ||
    (p.loading && p.status !== 'data') ||
    p.fetch;

  return !isBroken && !isLocked && !needsDownload && !isLoading;
};

export function getPropertyStatus(property: Property, isActive: boolean): PropertyRowStatus {
  const isStatusData = property.status === 'data';
  const hasData = property.data;
  const isBroken = property.status === 'broken' || property.status === 'warning';
  const isLocked = isStatusData && hasData && property.locked;
  const needsDownload = isStatusData && !hasData && !property.fetch;
  const isLoading =
    property.status === 'running' ||
    property.status === 'set_visible' ||
    (property.loading && !isStatusData) ||
    property.fetch;

  if (isLoading) {
    return 'loading';
  }
  if (isBroken) {
    return 'broken';
  }
  if (isLocked) {
    return 'locked';
  }
  if (needsDownload) {
    return 'needsDownload';
  }
  if (isActive) {
    return 'active';
  }
  return 'inactive';
}

const MUNICIPALITY_PREFIXES = new Set(['Upplands', 'Lilla', 'Östra']);

const capitalize = ([first, ...rest] = '') =>
  first ? first.toUpperCase() + rest.join('').toLowerCase() : '';

export const capitalizeAllWords = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ');
};
export function municipalityFromDesignation(designation: string) {
  const [firstWord, secondWord] = designation.split(' ');
  const capitalizedFirstWord = capitalize(firstWord);
  if (MUNICIPALITY_PREFIXES.has(capitalizedFirstWord) && secondWord) {
    return `${capitalizedFirstWord} ${capitalize(secondWord)}`;
  }
  return capitalizedFirstWord;
}

export const removePropertyFromCookie = (ref: string) => {
  const activePropsCookie = Cookies.get('activeProps');
  if (activePropsCookie) {
    const propList = activePropsCookie.split(',').filter((prop) => prop !== ref);
    Cookies.set('activeProps', propList.join(','));
  }
};

export const validateForestandFile = async (file: File): Promise<boolean> => {
  try {
    const content = await file.text();
    const xmlDoc = new DOMParser().parseFromString(content, 'text/xml');
    return xmlDoc.getElementsByTagNameNS('*', 'ForestandData').length > 0;
  } catch {
    return false;
  }
};
